var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusHandwritten(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7344 17.6C25.8274 17.7169 24.9152 17.7881 24.001 17.8133C23.0944 17.8133 22.1877 17.8133 21.3344 17.8133C20.481 17.8133 19.521 17.8133 18.6677 17.7333C17.8144 17.6533 16.8544 17.6 16.001 17.52C15.1477 17.44 14.1877 17.3466 13.3344 17.3066L12.001 17.2266H10.6677H9.33438H8.00105C7.09438 17.2266 6.18771 17.2266 5.33438 17.2266C4.81438 17.2266 4.40104 16.4667 4.41438 15.4534C4.42771 14.44 4.84102 13.6 5.34769 13.5867H5.46768C6.37435 13.7733 7.26768 13.92 8.13435 14.0267L9.46768 14.1867L10.801 14.32L12.1343 14.4267L13.4677 14.5067C14.3743 14.5733 15.281 14.5867 16.1343 14.6267H18.801C19.7077 14.6267 20.6143 14.6267 21.4677 14.6267C22.321 14.6267 23.281 14.6267 24.1343 14.5334C24.9877 14.44 25.9477 14.44 26.801 14.3467C27.2543 14.3467 27.6277 14.9867 27.6277 15.8667C27.6277 16.7467 27.281 17.5066 26.8277 17.56L26.7344 17.6Z",
    fill: "#173962"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusHandwritten);
export default __webpack_public_path__ + "static/media/minus-handwritten.4f734ed5b4b99d86051f5fada25ba481.svg";
export { ForwardRef as ReactComponent };